import { DayHeaderContentArg } from "@fullcalendar/core/index.js";
import { Typography } from "@mui/material";
import { format } from "date-fns";

import { useLanguageContext } from "@/common/contexts/language-context/LanguageContext";
import { locales } from "@/common/contexts/localization-date-context/LocalizationDateContextProvider.utils";
import { useTranslation } from "@/translations";

interface Props {
  arg: DayHeaderContentArg;
}

export function WeekDayHeaderTitle({ arg }: Props) {
  const { language } = useLanguageContext();
  const { t } = useTranslation();

  const title = arg.isToday
    ? `${t("calendar.today").toLowerCase()}, ${format(arg.date, "EE dd.MM.yyyy", { locale: locales[language] })}`
    : format(arg.date, "EE dd.MM.yyyy", { locale: locales[language] });

  return (
    <Typography variant="subtitle1" fontWeight={600} textAlign="left">
      {title}
    </Typography>
  );
}
